import { Component, PropsWithChildren } from "react";
import { app } from "@microsoft/teams-js";
import { FluentProvider, teamsLightTheme } from "@fluentui/react-components";
import TryAgain from "@/components/TryAgain/TryAgain";
import { strings } from "@/locales";
import type { ErrorBoundaryState } from "@/components/ErrorBoundary/ErrorBoundary.types";

const translate = (key: string) => {
  try {
    return strings(key);
  } catch {
    return key;
  }
};

export class ErrorBoundary extends Component<
  PropsWithChildren,
  ErrorBoundaryState
> {
  state: ErrorBoundaryState = { hasError: false };

  static getDerivedStateFromError(): ErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch() {
    app
      .initialize()
      .then(() => {
        app.notifyAppLoaded();
        app.notifySuccess();
      })
      .catch(() => undefined);
  }

  render() {
    if (this.state.hasError) {
      return (
        <FluentProvider theme={teamsLightTheme}>
          <TryAgain
            title={translate("Something went wrong")}
            description={translate("Try to contact us")}
            buttonTitle={translate("Try again")}
            onClick={() => window.location.reload()}
          />
        </FluentProvider>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
